import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import KlarnaPaymentCategoryProperties from './klarnaPaymentCategoryProperties.mdx';
import ValidatableDataNameProperty from '../_common/validatableDataNameProperty.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='KlarnaPaymentOptions' mdxType="Item">
      <p>{`Interface representing Klarna payment options required for configuring `}<a parentName="p" {...{
          "href": "/docs/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/klarna/klarnaManagerProvide#returns"
        }}>{`KlarnaComponent`}</a></p>
      <Group summary='Properties' mdxType="Group">
    <ValidatableDataNameProperty value='klarnaPaymentOptions' mdxType="ValidatableDataNameProperty" />
    <Item title='returnIntentUrl' subtitle='string' mdxType="Item">
        Url used by third-party Android apps to build the intent for returning to the app.
    </Item>
    <Item title='paymentCategory' subtitle='KlarnaPaymentCategory' mdxType="Item">
        Payment category required for session creation.
        <KlarnaPaymentCategoryProperties mdxType="KlarnaPaymentCategoryProperties" />
    </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      